module.exports = __webpack_public_path__ + "static/media/arrow-down.fcf149de.svg";